import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-settings" }
const _hoisted_2 = { class: "form-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "Gitlab Access Token (required scopes: api, read_api)", -1)
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transientToken) = $event))
      }, null, 512), [
        [_vModelText, _ctx.transientToken]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("button", {
      class: "button",
      disabled: !_ctx.username || _ctx.username.length === 0,
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSettings && _ctx.updateSettings(...args)), ["stop"]))
    }, "Save ", 8, _hoisted_4)
  ]))
}